import {useMutation, useQueryClient} from "@tanstack/vue-query";
import axios from "axios";

function useSitemap (mutationOptions = {}) {
  const queryClient = useQueryClient();

  const updateAutoAssignStatusMutation = useMutation({
    mutationFn: (data) => axios.patch('/ajax/v2/strategy/update-auto-assign-status', data),
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: ['auto-assign-status']});
    },
    ...mutationOptions,
  });

  return {
    updateAutoAssignStatusMutation,
  };
}

export default useSitemap;
